import {useNavigate} from 'react-router-dom'

import Style from './style'
import check from './asset/check.svg'
import checked from './asset/checked.svg'

import MainHeader from 'widget/MainHeader'
import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import useGetFranchiseList from 'entity/franchise/useGetFranchiseManagerList'
import usePutFranchiseManagerApprove from 'entity/franchise/usePostFranchiseManagerApprove'
import useDeleteFranchiseManagerApprove from 'entity/franchise/useDeleteFranchiseManagerApprove'
import useRoleCookie from 'shared/model/useRoleCookie'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TableLoading from 'shared/ui/TableLoading'
import {convertRoleAsName} from 'shared/constant/lookup/role'
import {ROLE_SUPER_ADMIN} from 'shared/constant/lookup/role'

const FranchiseManagerList = () => {
	const navigate = useNavigate()

	const [franchiseManagerList, isLoading] = useGetFranchiseList()
	const [approveManager] = usePutFranchiseManagerApprove()
	const [unapproveManager] = useDeleteFranchiseManagerApprove()

	const [userRole] = useRoleCookie()

	const sizeList = [
		'short',
		'medium',
		'long',
		'long',
		'expand',
		'long',
		'medium',
		'short',
		'long',
	]
	const tableHeadList = [
		'IDX',
		'역할',
		'이름',
		'연락처',
		'프랜차이즈',
		'대표 연락처',
		'매장 이름',
		'승인',
		'가입 날짜',
	]

	const btnList =
		userRole === ROLE_SUPER_ADMIN
			? [
					{
						label: '매니저 계정 생성',
						clickEvent: () => navigate('/manager/franchise/create'),
					},
				]
			: []

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList}>매니저 관리</MainHeader>
			<Search placeholder='이름, 연락처로 검색 가능합니다' />

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{franchiseManagerList?.data?.franchise_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => {
									// Store manager (role_flag === 2)
									if (elem?.manager_role_flag === 2) {
										navigate(`/manager/store/${elem?.idx}/detail`)
									} else {
										navigate(`/manager/franchise/${elem?.idx}/detail`)
									}
								}}
							>
								<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>
									{convertRoleAsName[elem?.manager_role_flag] || '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>{elem?.contact}</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>
									{elem?.franchise_name || '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[5]}>
									{elem?.franchise_contact || '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[6]}>
									{elem?.branch_name || '-'}
								</TStyle.Data>
								<TStyle.Data
									$size={sizeList[7]}
									onClick={(e) =>
										elem?.is_approve
											? unapproveManager(e, elem?.idx)
											: approveManager(e, elem?.idx)
									}
								>
									<Style.Radio>
										<img src={elem?.is_approve ? checked : check} alt='check' />
									</Style.Radio>
								</TStyle.Data>
								<TStyle.Data $size={sizeList[8]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={franchiseManagerList?.data?.max_page} />
		</Style.Wrapper>
	)
}

export default FranchiseManagerList
